<template>
  <div class="header" id="chery-header">
    <div class="header-content" v-if="showHeader">
      <div class="header-nav">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          style="background:none"
        >
          <el-menu-item index="1" style="background:none" @click="indexLink()">首页</el-menu-item>
          <el-submenu index="2">
            <template slot="title">我的应用</template>
            <el-menu-item v-for="(item, index) in myApplication" :key="index" @click="myAppLink(item.url)">{{
              item.name
            }}</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="header-user">
        <!-- <sp-lang></sp-lang> -->
        <el-dropdown class="userInfo">
          <div class="user-name">
            <el-badge :value="backlogNumber" class="badge-item">
              <span><img :src="imgUrl.agenda" alt=""/></span>
            </el-badge>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in backlogList"
              :key="index"
              style="width:370px;position:relative"
              @click.native="taskLink(item.callbackUrl)"
            >
              <p class="dropdown-p">{{ item.title }}</p>
              <span class="durationTime" style="position:absolute;right: 20px;top: 10px;color:#888888">{{
                durationTime(item.createdAt)
              }}</span>
            </el-dropdown-item>
            <!-- <el-dropdown-item class="check-wait-tip" v-if="backlogList.length != 0"> -->
            <el-dropdown-item class="check-wait-tip">
              <span>查看所有待办任务</span>
              <i class="el-icon-arrow-right"></i>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="userInfo">
          <div class="user-name">
            <el-badge :value="messageNumber" class="badge-item">
              <span><img :src="imgUrl.message" alt=""/></span>
            </el-badge>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in messageList"
              :key="index"
              style="width:370px"
              @click.native="messageLink(item.id)"
            >
              <p class="dropdown-p dropdown-message-line" style="width:320px">{{ item.title }}</p>
              <span class="dropdown-time">{{ $moment(item.updatedAt).format('YYYY-MM-DD hh:mm:ss') }}</span>
            </el-dropdown-item>
            <!-- <el-dropdown-item class="check-wait-tip" v-if="messageList.length != 0"> -->
            <el-dropdown-item class="check-wait-tip">
              <span>查看更多</span>
              <i class="el-icon-arrow-right"></i>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="userInfo">
          <div class="user-name">
            <el-badge :value="0" class="badge-item">
              <span><img :src="imgUrl.ask" alt=""/></span>
            </el-badge>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="setting" v-if="false">查看全部待办事项</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="userInfo">
          <span class="user-name">
            <!-- <el-avatar :size="24" class="avatar" :src="userInfo.avatar" />
            {{ userInfo.mobile }} -->
             <el-avatar :size="24" class="avatar" :src='avatarUrl' />
            {{ account}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="setting">账号设置</el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getSelfApps } from '../../api/login'
import imgUrl from '../../lib/imgUrl'
import { getAgendaList,getUnreadMessage  } from '@/api/headmenu'
import { durationTime } from '../../lib/utils'
export default {
  name: 'HeadMenu',
  components: {},
  data() {
    return {
      imgUrl,
      durationTime,
      activeIndex: '1', // 选中项
      myApplication: [], // 我的事项列表
      backlogNumber: 0, // 待办事项数量
      backlogList: [], // 待办事项列表数据
      messageNumber: 0, // 消息数量
      messageList: [] // 消息列表数据
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo
    })
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    mobile: {
      type: String,
      default: ''
    },
    account: {
      type: String,
      default: ''
    },
    avatarUrl:{
      type: String,
      default: ''
    }
  },
  methods: {
    logout() {
      login.logout().then((res) => {
        window.location.href = res.data
      })
    },
    setting() {
      this.$router.push({
        path: '/userInfo/details'
      })
    },
    handleSelect(key, keyPath) {},
    /**
     * @descripttion: 获取我的应用列表
     * @Author: cuiyuan
     * @Date: 2020-11-27 16:10:49
     * @param {void}
     * @return {void}
     */

    getapplication() {
      getSelfApps().then((res) => {
        this.myApplication = res
      })
    },
    /**
     * @descripttion: 我的应用跳转
     * @Author: cuiyuan
     * @Date: 2020-11-27 16:08:31
     * @param {string} url [我的应用跳转的url]
     * @return {void}
     */
    myAppLink(url) {
      window.location.href = url
    },
    /**
     * @descripttion: 首页跳转
     * @Author: cuiyuan
     * @Date: 2020-12-01 19:14:26
     * @param {void}
     * @return {void}
     */

    indexLink() {
      this.$router.push({
        path: '/'
      })
    },
    /**
     * @descripttion: 获取待办列表数据
     * @Author: cuiyuan
     * @Date: 2020-11-27 16:08:03
     * @param {void}
     * @return {void}
     */
    getAgendaList() {
      let params = {
        pageNo: 1,
        pageSize: 5,
        status: 'UNFINISH'
      }
      getAgendaList(params).then((res) => {
        this.backlogNumber = res.total
        this.backlogList = res.backlogs
      })
    },
    /**
     * @descripttion: 待办列表消息跳转
     * @Author: cuiyuan
     * @Date: 2020-11-27 15:52:58
     * @param {string} url [跳转的url]
     * @return {void}
     */
    taskLink(url) {
      window.open(url)
    },
    /**
     * @descripttion: 获取站内信列表
     * @Author: cuiyuan
     * @Date: 2020-11-27 16:45:15
     * @param {void}
     * @return {void}
     */

    getUnreadMessage() {
      let params = {
        pageNo: 1,
        pageSize: 5,
        read: false
      }
      getUnreadMessage(params).then((res) => {
        this.messageNumber = res.total
        this.messageList = res.messages
      })
    },
    /**
     * @descripttion: 消息跳转
     * @Author: cuiyuan
     * @Date: 2020-11-27 17:00:22
     * @param {string} id [这条消息id]
     * @return {void}
     */
    messageLink(id) {
      this.$router.push({
        name: 'detail',
        query: { id: id }
      })
    }
  },
  created() {
    this.getapplication()
    this.getAgendaList()
    this.getUnreadMessage()
  }
}
</script>

<style lang="scss" scoped>
.header-content {
  display: flex;
  .header-nav {
    width: 200px;
  }
  .header-user {
    width: calc(100% - 200px);
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-shadow: 0px 1px 1px 0px rgba(5, 21, 41, 0.12);
    .avatar {
      margin-right: 8px;
      cursor: pointer;
      vertical-align: middle;
      display: none;
    }
    .user-name {
      color: #c7c8d2;
      cursor: pointer;
      padding: 0 20px;
      height: 60px;
      display: flex;
      align-items: center;
      img {
        height: 36px;
        width: 36px;
      }
      .badge-item {
        height: 36px;
      }
    }
    .user-name:hover {
      border-bottom: 2px solid #c6001f;
    }
  }
}
.dropdown-p {
  margin: 0;
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #363636;
  line-height: 48px;
}
.dropdown-message-line {
  line-height: 30px;
}
.dropdown-time {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: #888888;
  line-height: 12px;
}
.check-wait-tip {
  text-align: center;
  color: #c6001f;
}
</style>
<style lang="scss">
#chery-header {
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #c6001f;
    color: #fff;
  }
  .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
      background-color: #c6001f !important;
  }
  .el-badge__content {
    border: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headMenu/head-menu.vue